export const ACCOUNT_TYPE_PAT = 'pat';
export const ACCOUNT_TYPE_PRO = 'pro';

export const PATIENT = 'patient';
export const PROFESSIONAL = 'professional';
